import { useTypedQuery } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

export const useTagsQuery = () => {
  const tagsQuery = useTypedQuery({
    queryKey: CheckInServicesQueryKeys.tags,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.tags
  });

  const tagsOptions = (tagsQuery.data ?? []).filter(tag => tag.is_system).map(tag => ({ key: tag.id, value: tag.id, text: tag.name }));

  return { ...tagsQuery, tagsOptions };
};
